// extracted by mini-css-extract-plugin
export default {"textArea":"AddBotMemories_textArea__2qc2A","content":"AddBotMemories_content__iPpu+","btn":"AddBotMemories_btn__N5zIw"};